import { render, staticRenderFns } from "./NotificationContactRequestCreated.vue?vue&type=template&id=13508505&scoped=true&lang=pug&"
import script from "./NotificationContactRequestCreated.vue?vue&type=script&lang=js&"
export * from "./NotificationContactRequestCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13508505",
  null
  
)

export default component.exports